"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_html_parser_1 = __importDefault(require("react-html-parser"));
const autolinker_1 = __importDefault(require("autolinker"));
const prop_types_1 = __importDefault(require("prop-types"));
const html_sanitizer_1 = require("../../utils/html-sanitizer");
require("../../styles/components/html-parser.less");
const buildHtml = (allowedTags, allowedClasses, text, autolinker) => (0, html_sanitizer_1.sanitizeRichTextContent)(autolinker.link(text), {
    allowedTags,
    allowedClasses,
    removeContentEditable: true,
});
const HtmlParser = ({ html, className, linkClassName, breakLine, allowedTags, allowedClasses }) => {
    const autolinker = (0, react_1.useMemo)(() => new autolinker_1.default({
        breakline: breakLine,
        className: linkClassName,
        stripTrailingSlash: false,
    }), [breakLine, linkClassName]);
    const htmlSanitized = (0, react_1.useMemo)(() => buildHtml(allowedTags, allowedClasses, html, autolinker), [allowedTags, allowedClasses, html, autolinker]);
    return react_1.default.createElement("div", { className: `html-parser-container ${className}` }, (0, react_html_parser_1.default)(`<div>${htmlSanitized}</div>`));
};
HtmlParser.defaultProps = {
    breakLine: false,
    className: '',
    linkClassName: '',
    allowedTags: undefined,
    html: '',
    allowedClasses: undefined,
};
HtmlParser.propTypes = {
    className: prop_types_1.default.string,
    breakLine: prop_types_1.default.bool,
    linkClassName: prop_types_1.default.string,
    allowedTags: prop_types_1.default.array,
    html: prop_types_1.default.string,
    allowedClasses: prop_types_1.default.object,
};
exports.default = HtmlParser;
//# sourceMappingURL=html-parser.js.map